import { render, staticRenderFns } from "./OurBeliefsConversationSection.vue?vue&type=template&id=0a0b68fb"
import script from "./OurBeliefsConversationSection.vue?vue&type=script&lang=ts"
export * from "./OurBeliefsConversationSection.vue?vue&type=script&lang=ts"
import style0 from "./OurBeliefsConversationSection.vue?vue&type=style&index=0&id=0a0b68fb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports